import { Component, OnInit ,Input} from '@angular/core';

import { Product } from '../../entities/product.entities'
import { ProductService } from '../../services/product.service'

import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-drink',
  templateUrl: './drink.component.html',
  styleUrls: ['./drink.component.css']
})
export class DrinkComponent implements OnInit {

  @Input('data') meals: string[] = [];
  page: number = 1;

  private products: Product[] = [];

  constructor(private productService: ProductService,private titleService: Title) { }

  ngOnInit() {
    this.titleService.setTitle("เครื่องดื่ม");
    this.productService.getProduct().subscribe((snapshot) => {
      let index: number = 0;
      for (var i = 0; i < snapshot.length; i++) {
        if (snapshot[i].type == '4') {
          this.products[index] = snapshot[i]
          index++;
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/components/drink/drink.component.ts